import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
/** How much an arrow key resizes the side panel, in px */
const KEYBOARD_RESIZE_STEP = 40;
/** Edge of the docked side panel, dragged or moved with the arrow keys to resize it */
export function MarkupSidePanelResizeHandle(t0) {
  const $ = _c(13);
  const {
    layout
  } = t0;
  let t1;
  if ($[0] !== layout) {
    t1 = function onKeyDown(event) {
      let direction;
      if (event.key === "ArrowLeft") {
        direction = 1;
      } else {
        if (event.key === "ArrowRight") {
          direction = -1;
        } else {
          return;
        }
      }
      event.preventDefault();
      const width = layout.width + direction * KEYBOARD_RESIZE_STEP;
      layout.resize(width);
      layout.persistWidth("keyboard", width);
    };
    $[0] = layout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onKeyDown = t1;
  let t2;
  let t3;
  if ($[2] !== layout) {
    t2 = event_1 => {
      if (event_1.currentTarget.hasPointerCapture(event_1.pointerId)) {
        layout.resize(window.innerWidth - event_1.clientX);
      }
    };
    t3 = () => layout.persistWidth("drag");
    $[2] = layout;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      width: "0.25rem",
      cursor: "ew-resize",
      zIndex: 2,
      "&:hover, &:focus-visible": {
        backgroundColor: "action.disabled",
        outline: "none"
      }
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== layout.maxWidth || $[7] !== layout.minWidth || $[8] !== layout.width || $[9] !== onKeyDown || $[10] !== t2 || $[11] !== t3) {
    t5 = <Box role="separator" tabIndex={0} aria-orientation="vertical" aria-label="Resize side panel" aria-valuenow={layout.width} aria-valuemin={layout.minWidth} aria-valuemax={layout.maxWidth} onKeyDown={onKeyDown} onPointerDown={_temp} onPointerMove={t2} onLostPointerCapture={t3} onPointerUp={_temp2} data-testid="markup-side-panel-resize-handle" sx={t4} />;
    $[6] = layout.maxWidth;
    $[7] = layout.minWidth;
    $[8] = layout.width;
    $[9] = onKeyDown;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(event_2) {
  event_2.currentTarget.releasePointerCapture(event_2.pointerId);
}
function _temp(event_0) {
  event_0.currentTarget.setPointerCapture(event_0.pointerId);
}